import { Component, OnInit } from '@angular/core';
import { ContentService } from '../../shared/content.service';

@Component({
  selector: 'app-tbs',
  templateUrl: './tbs.component.html',
  styleUrls: ['./tbs.component.scss']
})
export class TbsComponent implements OnInit {
  page: Object;

  constructor(private contentService: ContentService) {
  }

  ngOnInit() {
    this.page = this.contentService.pages['tbs'];
  }

}
